import React from "react";

import type {
  Procedure,
  ProcedureDetail,
  ProcValidation,
} from "../../../../application/domain/proc-management";
import {
  ProcedureContactsListInput,
  ProcedureDescriptionFilesListInput,
  ProcedureDescriptionInput,
  ProcedureIssueFilesListInput,
  ProcedureNoticeInput,
  ProcedureReferencesListInput,
} from "../../../molecules/proc-management/form";

type Props = {
  procedure: ProcedureDetail | Procedure;
  onChange: (path: (string | number)[], value: any) => void;
  onFileAttached: (
    path: (string | number)[],
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
  getFileUploading: (path: (string | number)[]) => boolean;
  isServiceProviderAccount?: boolean;
  disabled?: boolean;
  shouldDisplayError: boolean;
  validationErrors: ProcValidation;
};

export const SupportSection: React.FC<Props> = ({
  procedure,
  onChange,
  onFileAttached,
  getFileUploading,
  isServiceProviderAccount = false,
  disabled = false,
  shouldDisplayError = false,
  validationErrors,
}) => {
  const descFiles =
    Array.isArray(procedure.descriptionFiles) &&
    procedure.descriptionFiles.length > 0
      ? procedure.descriptionFiles
      : [];
  const contacts = procedure.contacts ?? [];
  const references = procedure.references ?? [];
  const issueFiles = procedure.issueFiles ?? [];
  return (
    <section className="mb-5">
      <h2 className="subtitle">手続き全体に関わる補足情報など</h2>

      <ProcedureDescriptionFilesListInput
        value={descFiles}
        onChange={onChange}
        disabled={disabled}
        basePath={["descriptionFiles"]}
        onFileAttached={onFileAttached}
        getFileUploading={getFileUploading}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors.descriptionFiles ?? []}
      />

      <ProcedureIssueFilesListInput
        value={issueFiles}
        onChange={onChange}
        disabled={disabled}
        basePath={["issueFiles"]}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors.issueFiles ?? []}
      />

      <ProcedureDescriptionInput
        basePath={["description"]}
        onChange={onChange}
        value={procedure.description}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={validationErrors.description}
      />

      <ProcedureNoticeInput
        basePath={["notice"]}
        onChange={onChange}
        value={procedure.notice}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={validationErrors.notice}
      />

      <ProcedureContactsListInput
        value={contacts}
        organizationId={procedure.jurisdiction.organizationId}
        isServiceProviderAccount={isServiceProviderAccount}
        onChange={onChange}
        basePath={["contacts"]}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors.contacts ?? []}
      />

      <ProcedureReferencesListInput
        value={references}
        onChange={onChange}
        disabled={disabled}
        basePath={["references"]}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors.references ?? []}
      />
    </section>
  );
};
